export default __webpack_public_path__ + "static/media/logo.32866b92.svg";